import React, { useContext, useEffect, useState } from "react";
import { PageNavContext } from "../../FunctionalPageLogin";
import './RightElements.css';
import '../../leftSidebar/pages/missions/Misiuni.css'; // importam stilurile de la Misiuni

import goalImg from '../../../../imagesHome/goal.png';
import xpImg from '../../../../imagesHome/bolt.png';
import quizMissionImg from '../../../../imagesHome/quiz_mission.png';
import puzzleMissionImg from '../../../../imagesHome/puzzle_mission.png';

const createMissionsFromDailyData = (dailyData = {}) => {
  const xpToday = Number(dailyData.xp_earned ?? 0);
  const lessonsToday = Number(dailyData.lessons_completed ?? 0);
  const applicationsToday = Number(dailyData.applications_completed ?? 0);

  return [
    { text: 'Castiga 30 XP', progress: xpToday, total: 30, img: xpImg },
    { text: 'Completeaza 3 lectii standard', progress: lessonsToday, total: 3, img: quizMissionImg },
    { text: 'Rezolva o lectie aplicativa', progress: applicationsToday, total: 1, img: puzzleMissionImg },
  ];
};

const DailyGoalsCard = () => {
  const onPageNav = useContext(PageNavContext);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [missions, setMissions] = useState(createMissionsFromDailyData());

  useEffect(() => {
    const fetchDailyMissions = async () => {
      try {
        const response = await fetch(`${apiUrl}/missions/today`, {
          method: 'GET',
          credentials: 'include',
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        setMissions(createMissionsFromDailyData(data));
      } catch (error) {
        console.error('Eroare la preluarea misiunilor:', error);
      }
    };

    fetchDailyMissions();
  }, [apiUrl]);

  const handleOpenMissions = (event) => {
    event.preventDefault();
    if (onPageNav) {
      onPageNav('Misiuni');
    }
  };

  return (
    <div className="rightmenu-card dailygoals-card" style={{ padding: '24px 28px', cursor: 'pointer' }} onClick={handleOpenMissions}>
      <div className="section daily-goals" style={{ marginTop: '0' }}>
        <div className="missions-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '22px' }}>
          <span>Misiuni zilnice</span>
          <img src={goalImg} alt="" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
        </div>
        
        <div className="missions-list" style={{ gap: '22px' }}>
          {missions.map((mission, index) => {
            const percent = mission.total > 0
              ? Math.min(100, Math.round((mission.progress / mission.total) * 100))
              : 0;
            const isCompleted = percent === 100;

            return (
              <div
                key={index}
                className={`mission-item ${isCompleted ? 'mission-completed' : ''}`}
              >
                <div className="mission-header">
                  <div className="mission-text">{mission.text}</div>

                  <div className="mission-right">
                    <span className="mission-percent">{mission.progress} / {mission.total}</span>
                    <img src={mission.img} alt="" className="mission-flag" style={{ width: '22px', height: '22px', objectFit: 'contain' }} />
                  </div>
                </div>

                <div className="mission-progress-bar">
                  <div
                    className="mission-progress-fill"
                    style={{ width: `${percent}%` }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DailyGoalsCard;
